'use strict';

const zeroPad = require('./zero-pad');

module.exports = function(secondsOverall, mode) {
    if (secondsOverall === undefined) {
        return undefined;
    }
    if (mode === 'short' && secondsOverall >= 60 * 60) {
        return '>59';
    }
    const minutes = Math.floor(secondsOverall / 60);

    if (mode === 'short' && minutes >= 10) {
        return minutes;
    }
    const seconds = zeroPad(secondsOverall % 60);
    const hours = Math.floor(minutes / 60);

    if (hours) {
        return hours + ':' + zeroPad(minutes % 60) + ':' + seconds;
    }

    return minutes + ':' + zeroPad(seconds % 60);
};
